<template>
  <v-app>
    <GlobalHeader />

    <v-main>
      <slot />
    </v-main>

    <ContentWrapper>
      <GlobalFooter />
      <GlobalScrollTop />
    </ContentWrapper>
  </v-app>
</template>

<script setup lang="ts">
useHead({
  titleTemplate: titleChunk => {
    return `${titleChunk}`
  },
})
</script>
